import { render, staticRenderFns } from "./CategoriaForm.vue?vue&type=template&id=6e09fa5a"
import script from "./CategoriaForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports